import { Controller } from 'react-hook-form';
import React from 'react';
import YesNoQuestion, {
    YesNoState,
} from '@alfa-retail-react/components/yes-no-question';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { OrderFormValues } from 'app/logic/pages/order/OrderPage';
import { OrderFormStore } from 'app/logic/pages/order/OrderFormStore';
import { ValidationRules } from 'app/form/ValidationRules';

export interface FatcaFormItemProps {
    /**
     * Хранилище состояния страницы ввода личных данных.
     */
    orderFormStore: OrderFormStore;
}

/**
 * Компонент согласия с условиями fatca
 * @constructor
 */
export const FatcaFormItem = ({ orderFormStore }: FatcaFormItemProps) => {
    const FATCA_FORM_ITEM_NAME = 'fatca';
    const { control, handleMultipleErrors, setFieldElement } =
        useFormContext<OrderFormValues>();

    return (
        <Controller<OrderFormValues>
            name={FATCA_FORM_ITEM_NAME}
            control={control}
            defaultValue={orderFormStore.fatca}
            rules={{ required: ValidationRules.required() }}
            render={({ field, fieldState }) => {
                return (
                    <YesNoQuestion
                        ref={(element) => {
                            field.ref(element);
                            setFieldElement(FATCA_FORM_ITEM_NAME, element);
                        }}
                        className={FATCA_FORM_ITEM_NAME}
                        error={handleMultipleErrors(fieldState.error)}
                        question={
                            'У вас есть виза США, Green Card либо почтовый адрес в США?'
                        }
                        value={field.value as YesNoState}
                        fields={[
                            { key: YesNoState.YES, title: 'Да' },
                            { key: YesNoState.NO, title: 'Нет' },
                        ]}
                        onChange={(event, value) => {
                            field.onChange(value);
                            orderFormStore.setFatca(value);
                        }}
                    />
                );
            }}
        />
    );
};
